module.exports = __webpack_public_path__ + "img/step_1.b938b55a.svg";